import ReactDOM from "react-dom";
import { React, setup, Router, Route, _ } from "utils";
import { Switch } from "react-router-dom";
import {
  Creators,
  SelectedPavilionStore,
  FairStore,
  Config,
  ActiveInfoStore,
} from "model";

import moment from "moment/src/moment";
import "moment/src/locale/en-gb";
import "moment/src/locale/hr";

import {
  Homepage,
  JobPage,
  IndexPage,
  PavilionPage,
  ActivityPage,
  EventsPage,
} from "pages";
import {
  MenuItems,
  InfoBox,
  Overlay,
  PrizeForm,
  PageListener,
} from "components";

import "../node_modules/font-awesome/scss/font-awesome.scss";
import "./styles.less";
import "../hacks/vvsources.css";

function openPavilionPage({ match }) {
  setTimeout(() => {
    var { stand, slug } = match.params;
    Creators.selectedStandChanged(stand);

    var selected = SelectedPavilionStore.getSelectedPavilionSlug();

    if (selected != slug) {
      Creators.loadPavilion(slug);
    }
  });

  return <PavilionPage />;
}

function reformatTranslations() {
  var ds = FairStore.getTranslations();

  var translations = [];

  ds.forEach((item) => {
    for (var key in item) {
      translations[key.toLowerCase()] = item[key];
    }
  });

  return translations;
}

function showInfo() {
  setTimeout(() => {
    Creators.setOverlayVisible("info", true);
  }, 1000);

  return null;
}

export function start(config) {
  setup(config);
  Creators.fairsChanged(config.superfair);
  Creators.pavilionsChanged(config.fair);
  config.translations = reformatTranslations();

  setup(config);
  moment.locale(config.locale);

  Creators.trackActiveInfo();

  $.when(Creators.loadStands()).done(() => {
    let view = (
      <Router>
        <div>
          <Switch>
            <Route exact={true} path="/info" component={Homepage} />
            <Route exact={true} path="/" component={Homepage} />
            <Route path="/jobs" component={JobPage} />
            <Route path="/events" component={EventsPage} />
            <Route exact={true} path="/index" component={IndexPage} />
            <Route
              path="/pavilion/:slug/stand/:stand/:type"
              component={ActivityPage}
            />
            <Route
              path="/pavilion/:slug/stand/:stand"
              render={openPavilionPage}
            />
          </Switch>
          <MenuItems />
          <InfoBox />
          <Overlay name="nagrada" title={_("Prize form")}>
            <PrizeForm />
          </Overlay>
          <Overlay name="info" title={_("info.title")}>
            <div
              className="col-12"
              dangerouslySetInnerHTML={{ __html: _("info.description") }}
            />
          </Overlay>
          <Route exact={true} path="/info" render={showInfo} />
          <PageListener />
        </div>
      </Router>
    );

    ReactDOM.render(view, config.container);
  });
}



// WEBPACK FOOTER //
// ./src/app.js